export default __webpack_public_path__ + "static/media/dyed-orchid.e5355260.webp";